export default __webpack_public_path__ + "static/media/business.dcf0499b.webp";